import { useState, useEffect } from "react";

import liff from "@line/liff";
import { CURRENT_ENV } from "../../Utills/constants";
import axios from "axios";

// แสดงการ์ด 6 ใบ
const mockCards = Array(6).fill({});

function CardGame() {
  const [flippedIndex, setFlippedIndex] = useState(null);
  const [cardRewards, setCardRewards] = useState(Array(6).fill(null));
  const [listRewards, setListRewards] = useState(null);

  useEffect(() => {
    const fetchRewards = async () => {
      try {
        const response = await axios.get(`${CURRENT_ENV.API_BASE_URL1}?path=getRewards`);
        if (response.data.status === 200) {
          setListRewards(response.data.data)
        }
      } catch (_) { }
      finally {
        // setLoading(false)
      }
    };
    fetchRewards();

  }, []);

  // Weighted Random
  const getRandomRewardIndex = () => {
    const total = listRewards.reduce((sum, c) => sum + c.percent, 0);
    const random = Math.random() * total;
    let cumulative = 0;
    for (let i = 0; i < listRewards.length; i++) {
      cumulative += listRewards[i].percent;
      if (random <= cumulative) return i;
    }
    return listRewards.length - 1;
  };

  const selectCard = (index) => {
    if (flippedIndex !== null) return;

    const rewardIndex = getRandomRewardIndex();
    const newCardRewards = [...cardRewards];
    newCardRewards[index] = listRewards[rewardIndex];
    setCardRewards(newCardRewards);
    setFlippedIndex(index);

  };

  return (
    <div className="container app-bg">
      <div style={{ textAlign: "center", padding: 20 }}>
        <h1>🃏 เกมจับการ์ด</h1>


        {listRewards ?
          (<div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gridGap: 10,
              justifyItems: "center",
              marginTop: 30,
            }}
          >
 {mockCards.map((_, index) => (

            <div
              key={index}
              style={{
                width: 100,
                height: 150,
                perspective: 1000,
                cursor: flippedIndex === null ? "pointer" : "default",
              }}
              onClick={() => selectCard(index)}
            >
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: 10,
                  backgroundColor: "#fff",
                  border: "2px solid #333",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: 14,
                  fontWeight: "bold",
                  transition: "transform 0.6s",
                  transformStyle: "preserve-3d",
                  transform: flippedIndex === index ? "rotateY(180deg)" : "rotateY(0deg)",
                }}
              >
                {/* ด้านหลังการ์ด */}
                <div
                  style={{
                    position: "absolute",
                    backfaceVisibility: "hidden",
                    width: "100%",
                    height: "100%",
                    borderRadius: 10,
                    backgroundColor: "#333",
                    color: "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  CARD
                </div>

                {/* ด้านหน้าการ์ด */}
                <div
                  style={{
                    position: "absolute",
                    backfaceVisibility: "hidden",
                    width: "100%",
                    height: "100%",
                    borderRadius: 10,
                    backgroundColor: "#fff",
                    color: "#333",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    transform: "rotateY(180deg)",
                    padding: 5,
                  }}
                >
                  {cardRewards[index] ? (
                    <>
                      <img src={cardRewards[index].image} alt={cardRewards[index].name} style={{ width: 60 }} />
                      <div>{cardRewards[index].name}</div>
                    </>
                  ) : (
                    <div>?</div>
                  )}
                </div>
              </div>
            </div>

            ))}
          </div>
          )
          
          : (
            <p>⏳ กำลังโหลดของรางวัล...</p>
          )}


        {
          flippedIndex ?
            <div>
              <div style={{ display: `flex`, flexDirection: `row`, backgroundColor: `#ffffff94`, borderRadius: 20, justifyContent: `center`, alignContent: `center`, overflow: `scroll`, padding: 5, fontSize: 18, fontWeight: `bold`, border: `3px solid #9bff15`, margin: 20 }}>
                🎉 คุณได้: {cardRewards[flippedIndex].name}
              </div>
            </div>
            : null
        }


        {
          listRewards ?
            <div style={{ marginTop: 10 }}>
              {/* <h2 className="txt-title">ของรางวัล</h2> */}
              <div style={{ display: `flex`, justifyContent: `center`, padding: 10, overflow: `scroll`, height: 200 }}>
                <div style={{ display: `grid`, width: `100%` }}>
                  <div className="grid-container">
                    {
                      listRewards?.map((data, index) => (
                        <div key={index}>
                          <div style={{ display: `flex`, justifyContent: `center`, alignItems: `center`, flexDirection: `column`, margin: 2, fontSize: 12 }}>
                            <img src={data.image} alt="" style={{ width: 30 }} />
                            <div>
                              {data.name}
                            </div>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div> : null
        }
      </div>
    </div>
  );
}

export default CardGame;
